export default __webpack_public_path__ + "static/media/android.170a8226.svg";